//This is for POS Print

import React from "react";
import "./stylePos.css";
import {currecy, currency} from "../../../../MUI_components/currencyFormatterTag"
import { useSelector } from "react-redux";
import { company } from "titum-custom/details";
import BillHeader from "Components/Print/billHeaderPos";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";

const PrintBill = React.forwardRef((props, ref) => {
  const { code, date } = useSelector((state) => state.lastInsertInvoice);
  const printedDate = date ? new Date(date) : new Date();
  const { returnData, value, invoice } = props;
  

  //Stock History Level
  const handleLineTotal = (qty, price, discountPer, discountAmount) => {
    let totalAmount = qty * price;
    discountAmount = discountAmount * qty;
    let lineTotalAmount = totalAmount - totalAmount * (discountPer / 100) - discountAmount;
    return lineTotalAmount;
  };

  const returnedTotal = returnData ? returnData
  .map((total) => total.totalAmount)
  .reduce((prev, curr) => prev + curr, 0) : ""

  return (

    <div className ref={ref}>

      <div className="billBody" >
        <BillHeader />

        <div className="text-center " style={{ fontSize: 12 }}>
          <div style={{ textAlign: "center", fontSize: 12 }}>{company.address}</div>
          <div style={{ textAlign: "center", fontSize: 12 }} >TEL: {company.phone} / {company.phone2} </div>
        </div>

        <div style={{ borderTop: "1px solid #000", marginBottom: 2 }} ></div>

        <div >
          <div className="flex" >
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.INVOICE_NUMBER}:</strong> &nbsp;
            <strong style={{ fontSize: 11 }}>   {invoice ? invoice.code : ""}</strong>
          </div>

          <div className="flex" >
            <strong style={{ fontSize: 11 }}>CUSTOMER: {value?.firstName ? value.firstName : "Cash"} / {value?.phone1 == '1111111111' ? "" : value.phone1}</strong>&nbsp;
          </div>

          <div className="flex" >
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.DATE}: </strong>&nbsp;
            <strong style={{ fontSize: 11 }}>{printedDate.toLocaleString()}</strong>
          </div>
        </div>

        <div style={{ borderBottom: "1px solid #000", marginTop: 2 }}></div>

        <table >
          <thead>
            <tr style={{ borderBottom: "1px solid #000" }}>
              <th>#</th>
              <th>{COLUMNS_NAME.BARCODE}</th>
              <th width="80%">{COLUMNS_NAME.DESCRIPTION}</th>
              <th align="right" style={{ paddingLeft: 10 }}>{COLUMNS_NAME.QUANTITY}</th>
              <th align="right" style={{ paddingLeft: 10 }}>{COLUMNS_NAME.UNIT_SOLD_PRICE}</th>
              <th align="right" style={{ paddingLeft: 10 }}>{COLUMNS_NAME.TOTAL}</th>
            </tr>
          </thead>

          <tbody>

{returnData ? returnData.map((item, index) => (
  <tr>
    <td>{index + 1}</td>
    <td>{item.itemMaster.barcode}</td>
    <td align="center">{item.itemMaster.name}</td>
    <td align="right">{item.quantity}</td>
    <td align="right">{currency(item.unitSoldPrice)}</td>
    <td align="right">{currency(item.totalAmount)}</td>

  </tr>
)) : ""}


</tbody>

        </table>

        <div style={{ borderBottom: "1px solid #000" }}></div>
        
        <div
          className="flex-print  mb  justify-content-spaceBetween"
          style={{ borderTop: "1px solid #000" }}
        >
          <strong style={{ fontSize: 16 }}>{COLUMNS_NAME.LAST_TOTAL} :</strong>

          <strong style={{ fontSize: 16 }}>{currency(returnedTotal)}</strong>
        </div>

     

        <div style={{ borderBottom: "1px solid #000" }}></div>

        {/* PRINT WITH BIZX FOOTER */}
        <small className="mt  text-center" >

          <div style={{ fontSize: 11 }} >
            THANK YOU COME AGAIN <br />
            SOLUTION BY TITUM (PVT) LTD <br />
            {TitumDetails.WEB} | {TitumDetails.EMAIL_ID}

          </div>
        </small>
      </div>

    </div>
  )
});

export default PrintBill;

// mt-margin top mb-marigin bottom
// justify-content-spaceBetween - vertical space
// #000 - black